angular.module('tf.services')

    .config(function(){
        /* jshint ignore:start */

        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', 'UA-79184359-1', 'auto');
        ga('require', 'autotrack');
        ga('send', 'pageview');

        /* jshint ignore:end */
    })


    .factory('GoogleAnalyicsService', [function () {
        var service = {};

        return service;
    }])

;
